import { Component, EventEmitter, Output } from "@angular/core";

@Component({
  selector: "app-page-count-handler",
  templateUrl: "./page-count-handler.component.html",
  styleUrls: ["./page-count-handler.component.css"],
})
export class PageCountHandlerComponent {
  
  @Output() pageNumberOfCount = new EventEmitter<number>();

  paginationCount(value: number): void {
    this.pageNumberOfCount.emit(value);
  }
}
